import { render, staticRenderFns } from "./soulLand3d.vue?vue&type=template&id=0a836e42&scoped=true"
import script from "./soulLand3d.vue?vue&type=script&lang=js"
export * from "./soulLand3d.vue?vue&type=script&lang=js"
import style0 from "./soulLand3d.vue?vue&type=style&index=0&id=0a836e42&prod&lang=scss&scoped=true"
import style1 from "./soulLand3d.vue?vue&type=style&index=1&id=0a836e42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a836e42",
  null
  
)

export default component.exports